import { combineReducers } from "redux";

import budgetReducer from "./budget.reducer";
import varsReducer from "./vars.reducer";
import userReducer from "./user.reducer";
import tagReducer from './tag.reducer';
import accountReducer from './account.reducer';
// import { batch } from './batch.reducer';
// import { lead } from './lead.reducer';

const rootReducer = combineReducers({
  budgetReducer,
  varsReducer,
  userReducer,
  tagReducer,
  accountReducer,
  //   course,
  //   batch,
  //   lead
});

export default rootReducer;
